import React from "react-native";
import { useTheme } from "../../theme";
import { TooltipIcon } from "./tooltip-icon";
import { IconProps } from "../icon";

export function TooltipInfoIcon({
    title,
    size,
    style,
}: {
    title: string;
    size?: IconProps["size"];
    style?: IconProps["style"];
}) {
    const theme = useTheme();
    return (
        <TooltipIcon
            icon="info"
            color={theme.colors.info}
            title={title}
            style={style}
            size={size}
        />
    );
}
